import { render, staticRenderFns } from "./ConclusionItem.vue?vue&type=template&id=534f8b5c&scoped=true&"
import script from "./ConclusionItem.vue?vue&type=script&lang=js&"
export * from "./ConclusionItem.vue?vue&type=script&lang=js&"
import style0 from "./ConclusionItem.vue?vue&type=style&index=0&id=534f8b5c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "534f8b5c",
  null
  
)

export default component.exports